import apiUrls from "constants/apiUrls";
import axios from "axios";

function wpGet(postType) {
  let url = apiUrls.WP_GET + postType;
  return axios.get(url);
}

export { wpGet };
